var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[(_vm.loaded == 0)?_c('loading-card'):_vm._e(),_vm._v(" "),(_vm.loaded > 0)?_c('div',[_c('bar-chart',{attrs:{"data":_vm.report,"options":_vm.options}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }